/**
 * @file   src\components\InstallApplication.tsx
 * @brief  InstallApplication component.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {Button, useState, useEffect, React } from '../utils/thirdpartyComponents';
import Appimg from "../assets/images/CW-appicon.svg";
import Closeicon from "../assets/images/close-icon-small.svg";
import { useAddToHomescreenPrompt } from "../components/UseAddToHomescreenPrompt";
import { getFromLocalStorage } from 'src/utils/helper';

const InstallApplication = () => {

    const [prompt, promptToInstall] = useAddToHomescreenPrompt();
    const [isVisible, setVisibleState] = useState(false);

    const hide = () => {
        setVisibleState(false);
        // Set a cancel status in sessionStorage when the user clicks the "Cancel" button
        localStorage.setItem('installPromptCancelled', 'true');
    };

    const accept = () => {
        setVisibleState(false);
        promptToInstall()
    };

    useEffect(
        () => {
        // Check the cancel status from sessionStorage in the useEffect hook to decide whether to show the installation prompt
        // if (sessionStorage.getItem('installPromptCancelled') === 'true') {
        //     return;
        // }
        if (prompt) {
            setVisibleState(true);
        }
        },
        [prompt]
    );

    if (!isVisible) {
        return <div />;
    }

    const settings = getFromLocalStorage('CARWASH_COMPANY_SETTINGS_DATA') || {};
    const IsCustom = settings?.IsCustom ? settings.IsCustom : 0;
    //if default design set defalut logo
    const Logourl_from_appsettings = IsCustom === 0 ? "" : getFromLocalStorage('LOGO_URL_SETTINGS_DATA');

  return (
      <div className="install-container" >
        <div className="app-body">
            <Button variant="light" className="close-btn" onClick={hide}><img src={Closeicon} width={14} height={14} alt="Car Wash App" /></Button>
            <div className="app-info d-flex align-items-center">
                <img src={Logourl_from_appsettings ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH}${Logourl_from_appsettings}` : Appimg } alt="Car Wash App" width={60} />
                <div className="app-name">
                    <h6>PWA</h6>
                    <p>carwashapp.com</p>
                </div>
            </div>
            <p>Installation component for Progressive Web Application CAR WASH APP</p>
        </div>
        <div className="app-footer">
            <p className="note">This site has app functionality. Install it on your device for
            extensive experience and easy access.</p>
            <div className="btn-sec">
                <Button variant="light" onClick={hide}>Cancel</Button>
                <Button variant="primary" className="primary-btn" onClick={accept}>Install</Button>
            </div>
        </div>
      </div>
  );
};
export default InstallApplication;
